import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useGameOfLife } from '../hooks/useGameOfLife';

export function InteractiveBackground() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const location = useLocation();
  useGameOfLife(canvasRef);

  let opacity = 0.45;
  if (location.pathname.startsWith('/grid')) opacity = 0.15;
  else if (location.pathname.startsWith('/manifesto')) opacity = 0.3;

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-auto"
      style={{
        zIndex: -1,
        opacity,
        transition: 'opacity 400ms ease',
        background: '#000000',
      }}
      aria-hidden="true"
    />
  );
}
